// @flow
import IndexView from '../index/IndexView';
export default IndexView;



// WEBPACK FOOTER //
// ./src/pages/index.js